import FontFaceObserver from 'fontfaceobserver'
import Logger from './Logger'
import App from './App'

export default class Fonts {

    static fonts = []
    static loadedFonts = []

    /**
     * Check if specified font is loaded
     * @param {string} fontName name of font
     * @returns boolean
     */
    static isLoaded(fontName) {
        return this.loadedFonts.includes(fontName)
    }

    /**
     * Fetch a font resource
     * @param {string} fontName name of font
     * @returns font resoure 
     */
    static async fetch(fontName) {
        Logger.log(`[Fonts][Fetch] Fetch ${fontName}`)
        return fetch(`${App.assetsPath}/fonts/${fontName}/Regular.ttf`).then((resp) => resp.arrayBuffer())
    }

    /**
     * Load a specified font
     * @param {string} fontName name of font
     * @returns result
     */
    static async load(fontName) {

        if (this.isLoaded(fontName)) {
            Logger.log(`[Fonts][Load] Font ${fontName} already loaded`)
            return true
        }

        try {
            const fontResponse = await this.fetch(fontName)
            const fontFace = new FontFace(fontName, fontResponse)

            document.fonts.add(fontFace);

            Logger.log(`[Fonts][Load] Adds ${fontName} font`)

            const fontObserver = new FontFaceObserver(fontName);

            await fontObserver.load(null, 3000)

            Logger.log(`[Fonts][Load] Loaded ${fontName} font`)

            this.loadedFonts.push(fontName)

        } catch {
            Logger.log('[Fonts][Load] Cannot load ', fontName)
        }

        return true
    }

    /**
     * Load fonts for specified project
     * @param {Project} project 
     */
    static async loadForProject(project) {
        Logger.log('[Fonts][loadForProject] ', project.name)
        await Promise.all(project.getUsedFonts().map((font) => this.load(font)))
    }

    static async getAvailable() {
        try {
            
            const response = await fetch(`${App.assetsPath}/fonts/config.json`)

            this.fonts = await response.json()

            return this.fonts

        } catch {
            return []
        }
    }

    static getFontConfig(fontFamily) {
        return this.fonts.find((config) => config.value === fontFamily)
    }
}